"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoveredCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const CardContent_1 = __importDefault(require("./CardContent"));
const CardTitle_1 = __importDefault(require("./CardTitle"));
const StyledCard = (0, styled_components_1.default)(core_1.Card) `
  background-color: #f7f8fc;
  .no-content {
    font-style: italic;
  }
`;
const HoveredCard = props => {
    const { title, icon, content, actions, className } = props;
    return (react_1.default.createElement(StyledCard, { elevation: 0, className: className },
        react_1.default.createElement(CardTitle_1.default, null,
            icon,
            title),
        react_1.default.createElement(CardContent_1.default, null, content ? (content) : (react_1.default.createElement(core_1.Typography, { variant: 'body1', color: 'textSecondary', className: 'no-content' }, "No content available."))),
        actions && react_1.default.createElement(core_1.CardActions, null, actions),
        react_1.default.createElement(core_1.Divider, null)));
};
exports.HoveredCard = HoveredCard;
exports.default = exports.HoveredCard;
//# sourceMappingURL=HoveredCard.js.map